module.exports = "/_next/static/images/image-48ede56d0d11524ba0428e2c1395e7fd.jpg";